module.exports = __webpack_public_path__ + "img/2.cd5f5070.jpg";